import dynamic from 'next/dynamic';

import { BlockLoadingSpinner } from 'components/LoadingSpinner';

import type { Props } from './FAQSupport';

const FAQSupportSuspense = dynamic(() => import('./FAQSupport'), {
	loading: () => <BlockLoadingSpinner />,
});

export default function DynamicFAQSupport(props: Props) {
	return <FAQSupportSuspense {...props} />;
}
DynamicFAQSupport.displayName = 'DynamicFAQSupport';
